<template>
	<div class="index-panel">
		<div class="title"><span class="bar">{{title}}</span><slot name="legend"></slot></div>
		<div class="body">
			<slot></slot>
		</div>
	</div>
</template>
<script>
	export default {
		name: "IndexPanel",
		props: ['icon','title'],
		mounted() {
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/panel/IndexPanel.vue